import { render, staticRenderFns } from "./scope_onpay.vue?vue&type=template&id=895bbcba&scoped=true&"
import script from "./scope_onpay.vue?vue&type=script&lang=js&"
export * from "./scope_onpay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "895bbcba",
  null
  
)

export default component.exports